const themes = {
    colors: {
        gray_100: "#EFEFEF",
        gray_300: "#E6E6E6",
        gray_500: "#BABABA",
        gray_600: "#B5B5B5",
        gray_700: "#9A9A9A",
        gray_900: "#999999",
        gray_1000: "#595959",
        navy_500: "#14141433",
        blue_500: "#6cc9ff",
        blue: "#2496ff",
        black: "#000000",
        black_500: "#303644",
        white: "#ffffff",
        bgColor: "#F8F8F8",
    },
};

export default themes;
